import { Pipe, PipeTransform } from '@angular/core';
import { Municipio } from 'src/app/models';

type SortingType = 'asc' | 'desc' | 'defect' | 'firstMunicipalitiesSelectedAndAsc';

@Pipe({
    name: 'sortListMunicipalities',
    standalone: false
})
export class SortListMunicipalitiesPipe implements PipeTransform {

    transform(
        municipalities: Municipio[],
        selectedMunicipalities: number[] = [],
        sortingType: SortingType = 'defect',
        search: string = ''
    ): Municipio[] {
       
        if (!municipalities || municipalities.length === 0 || sortingType === 'defect') {
            return municipalities;
        }

        // Funcion que se reutiliza para ordenar
        const hasNumberInSearch = /\d/.test(search);

        const extractNumber = (text: string): number => {
            const match = text.match(/\d+/);
            return match ? parseInt(match[0], 10) : Number.MAX_SAFE_INTEGER;
        };

        const compareByName = (a: Municipio, b: Municipio) => {

            // 🔹 SI NO hay número en búsqueda → orden normal
            if (!hasNumberInSearch) {
                return a.Nombre.localeCompare(b.Nombre, undefined, {
                    sensitivity: 'base'
                });
            }

            // 🔹 SI hay número → orden natural por número
            const numA = extractNumber(a.Nombre);
            const numB = extractNumber(b.Nombre);

            if (numA !== numB) {
                return numA - numB;
            }

            return a.Nombre.localeCompare(b.Nombre, undefined, {
                sensitivity: 'base'
            });
        };

        let sortedMunicipalities: Municipio[] = [];

        switch (sortingType) {
            case 'asc':
                sortedMunicipalities = municipalities.slice().sort(compareByName);
                break;

            case 'desc':
                sortedMunicipalities = municipalities.slice().sort((a, b) => compareByName(b, a));
                break;

            case 'firstMunicipalitiesSelectedAndAsc':
                const selected = municipalities.filter(mun => selectedMunicipalities.includes(mun.IdMunicipio)).sort(compareByName);
                const rest = municipalities.filter(mun => !selectedMunicipalities.includes(mun.IdMunicipio)).sort(compareByName);
                sortedMunicipalities = [...selected, ...rest];
                break;

            default:
                sortedMunicipalities = municipalities;
        }

        return sortedMunicipalities;
    }
}
